export const joinStrings = (...parts: (string | null | undefined)[]) => parts.filter(Boolean).join(' ')
